import { ShoppingListPagedQueryResponse } from "@commercetools/platform-sdk";
import { useQuery } from "@tanstack/react-query";
import { Session } from "next-auth";
import { useSession } from "next-auth/react";

import { createApiClient } from "@/clients/commercetools";

export const fetchShoppingList = async (session: Session | null) => {
  if (!session) return null;
  if (session.isAnonymous) return null;
  const api = createApiClient(session!.accessToken);

  const queryArgs = { sort: "createdAt desc", expand: "lineItems[*].variant", limit: 500 };
  const response = await api.me().shoppingLists().get({ queryArgs }).execute();
  return response.body;
};

export const useShoppingListQuery = () => {
  const { data: session } = useSession();
  return useQuery<ShoppingListPagedQueryResponse | null, Error>(["SHOPPING_LIST", session], () =>
    fetchShoppingList(session),
  );
};
